import { languageRepositoryImplementation } from '@shared/infrastructure/http/repositories/language/languageRepositoryImplementation';
import { Language } from './language.aggregate';

export interface LanguageRepository {
  getLanguages: () => Promise<Language[]>;
}

export const languageRepository: LanguageRepository = {
  getLanguages: () => {
    return languageRepositoryImplementation.getLanguages();
  }
};
